import fm from 'format-message';
import { FacetMap } from '@activebrands/core-web/types/faceting';

/*
 * Used to display label for filters on category pages and the search page
 * Remember to add facetDataExtractors in @activebrands/core-server/utils/facets.ts
 */
export const facetMap: FacetMap = {
    // 'inStock': {
    //     label: fm('Show only in stock'),
    //     type: 'property',
    //     param: 'inStock',
    // },
    'activity': {
        label: fm('Activity'),
        type: 'set',
        param: 'activity',
    },
    'additionalFitOptions': {
        label: fm('Additional fit options'),
        type: 'set',
        param: 'additionalFitOptions',
    },
    'breathability': {
        label: fm('Breathability'),
        type: 'set',
        param: 'breathability',
    },
    'category': {
        label: fm('Category'),
        type: 'set',
        param: 'category',
    },
    'collection': {
        label: fm('Collection'),
        type: 'set',
        param: 'collection',
    },
    'color': {
        label: fm('Color'),
        type: 'set',
        param: 'color',
    },
    'fit': {
        label: fm('Fit'),
        type: 'set',
        param: 'fit',
    },
    'gender': {
        label: fm('Gender'),
        type: 'set',
        param: 'gender',
    },
    'intensityZone': {
        label: fm('Intensity zone'),
        type: 'set',
        param: 'intensityZone',
    },
    'lens': {
        label: fm('Lens'),
        type: 'set',
        param: 'lens',
    },
    'materials': {
        label: fm('Materials'),
        type: 'set',
        param: 'materials',
    },
    'price': {
        label: fm('Price'),
        type: 'range',
        param: 'price',
    },
    'productType': {
        label: fm('Product type'),
        type: 'set',
        param: 'productType',
    },
    'size': {
        label: fm('Size'),
        type: 'set',
        param: 'size',
    },
    'sustainability': {
        label: fm('Sustainability'),
        type: 'set',
        param: 'sustainability',
    },
    'technologies': {
        label: fm('Technology'),
        type: 'set',
        param: 'technologies',
    },
    'vlt': {
        label: fm('VLT'),
        type: 'set',
        param: 'vlt',
    },
    'waterproofness': {
        label: fm('Waterproofness'),
        type: 'set',
        param: 'waterproofness',
    },
    'warmth': {
        label: fm('Warmth'),
        type: 'set',
        param: 'warmth',
    },
    'weatherConditions': {
        label: fm('Weather conditions'),
        type: 'set',
        param: 'weatherConditions',
    },
    'weatherConditionsLens': {
        label: fm('Weather conditions'),
        type: 'set',
        param: 'weatherConditionsLens',
    },
};

/*
 * Facets template for Algolia Facets
 */

export const getAlgoliaFacetsMapByMarketId = (marketId: string, pricelistId: string): FacetMap => {
    const algoliaFacetsMap: FacetMap = {
        'activity': facetMap['activity'],
        'additional_fit_options': facetMap['additionalFitOptions'],
        'breathability': facetMap['breathability'],
        'collection': facetMap['collection'],
        'filter_categories': facetMap['category'],
        'filter_colors': facetMap['color'],
        'filter_technologies': facetMap['technologies'],
        'fit': facetMap['fit'],
        'gender': facetMap['gender'],
        'intensity_zone': facetMap['intensityZone'],
        'lens': facetMap['lens'],
        'materials': facetMap['materials'],
        'price': facetMap['price'],
        'product_type': facetMap['productType'],
        'sustainability': facetMap['sustainability'],
        'vlt': facetMap['vlt'],
        'warmth': facetMap['warmth'],
        'waterproofness': facetMap['waterproofness'],
        'weather_conditions': facetMap['weatherConditions'],
        'weather_conditions_lens': facetMap['weatherConditionsLens'],
    };

    // The size facet is dynamic by market
    const sizesKey = `sizes_by_market_stock.${marketId}`;
    algoliaFacetsMap[sizesKey] = facetMap['size'];

    const priceKey = `pricelists_prices.${pricelistId}`;
    algoliaFacetsMap[priceKey] = facetMap['price'];

    return algoliaFacetsMap;
};

/*
 * Some attributes only have values, add the label with this map
 */

export const attributeValueLabelMap: Record<string, string> = {
    // Example data:
    // 'women': fm('Women'),
    // 'men': fm('Men'),
    // 'unisex': fm('Unisex'),
};
